import React from 'react';

interface Props {
	children: React.ReactNode;
}

interface State {
	hasError: boolean;
}

class BadgerErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError() {
		return { hasError: true };
	}

	render() {
		if (this.state.hasError) {
			return null;
		}
		return this.props.children;
	}
}

export default BadgerErrorBoundary;
